<div class="timeline-container">
  <div class="card-time">
    <h4 *ngIf="timeline.seqTimeline">{{ timeline.dataHora | date:'HH:mm'}}
      <small>{{ timeline.dataHora | date:'dd/MM/yyyy'}}</small>
    </h4>
  </div>

  <div class="card-dot">
    <em class="fa fa-circle"></em>
  </div>

  <div class="panel card-panel">
      <div class="step">
        <div class="content">
          <span class="icon"></span>
          <h2 *ngIf="!permiteLinkParaFicha">{{ timeline.tituloStatus }}</h2>
          <h2 *ngIf="permiteLinkParaFicha" (click)="irParaFicha()" class="cursor-pointer">{{ timeline.tituloStatus }}</h2>
          <span>{{ timeline.subTituloStatus}}</span>

          <div *ngIf="timeline.resultadoParcial">{{ proposta.produto }}</div>
          <div *ngIf="exibeDetalhePagamento">
            <div class="p descricao-complemento" *ngFor="let pagamento of detalhePagamento;">
              <div class="p devolucao-pgt" *ngIf="pagamento.efetivado">
                <span class="p" *ngIf="exibeFavorecidoPagamento">{{ pagamento.destinoLiberacao }} - </span>
                Efetivado em {{ pagamento.dataPagamento | date:'dd/MM/yyyy HH:mm'}}
              </div>
              <div class="p devolucao-pgt" *ngIf="pagamento.inconsistente">
                <div class="p"><em class="fa fa-exclamation-triangle fa-lg" color-orange></em></div>
                <div class="p descricao-pagamento">
                  <span class="p" *ngIf="exibeFavorecidoPagamento">{{ pagamento.destinoLiberacao }} - </span>
                  Devolução em {{ pagamento.dataDevolucao | date:'dd/MM/yyyy'}} por <strong>{{ pagamento.motivoDevolucao }}</strong>
                </div>
              </div>
              <div class="p devolucao-pgt" *ngIf="!pagamento.efetivado && !pagamento.inconsistente">
                <div class="p"><em class="fa fa-clock-o fa-lg" color-grey></em></div>
                <div class="p descricao-pagamento">
                  <span class="p" *ngIf="exibeFavorecidoPagamento">{{ pagamento.destinoLiberacao }} - </span>
                  Em processamento
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="timeline.finalizado" class="complemento">
          <div class="row" *ngIf="timeline.informacaoComplementar">
            <div class="col-xs-12">
                <div class="p descricao-complemento">
                    {{ timeline.informacaoComplementar?.descricao }}
                </div>
            </div>
          </div>
          <div class="row" *ngIf="timeline.resultadoParcial">
            <div class="col-xs-5">
                <div class="p">Valor Financiado</div>
                <div class="p">{{ timeline.resultadoParcial.valorLiquido  || 0 | currency:'BRL':'symbol':'1.2-2' }}</div>
                <div class="p">{{ timeline.resultadoParcial.qtdParcelas }}x
                {{ timeline.resultadoParcial.valorParcela  || 0 | currency:'BRL':'symbol':'1.2-2' }}</div>
            </div>
            <div class="col-xs-7" *ngIf="timeline.resultadoParcial.seguro">
              <small>
                <div class="p">Proteção Selecionada</div>
                <div class="p">{{ timeline.resultadoParcial.seguro?.descricao }}</div>
              </small>
            </div>
          </div>
        </div>
        <div *ngIf="!timeline.finalizado" class="complemento">
          <form [formGroup]="diasGeracaoContratoForm" class="forms content" *ngIf="timeline.informacaoComplementar?.diasGeracao">
            <div class="row">
              <div class="col-xs-12">
                <label class="h4" for="diasGeracaoValor">Selecione a quantidade de dias para a geração do contrato</label>
                <select formControlName="diasGeracaoValor"
                        name="diasGeracaoValor"
                        class="form-control h4"
                        id="diasGeracaoValor"
                        requiredMessage="Selecionar Dias para Geração é Obrigatório"
                        (change)="atualizaDiasGeracaoContrato(diasGeracaoContrato)">
                  <option value="" selected hidden>Selecione...</option>
                  <option *ngFor="let dia of timeline.informacaoComplementar?.diasGeracao" value="{{ dia.valor }}">{{ dia.descricao }}</option>
                </select>
              </div>
            </div>
          </form>
          <form [formGroup]="promotorForm" class="forms content" *ngIf="timeline.informacaoComplementar?.propostaAutomatica">
            <div class="row">
              <div class="col-xs-12">
                <label class="h4" for="promotorId">Nome do Operador</label>
                  <select formControlName="promotorId"
                  name="promotorId"
                  class="form-control h4"
                  id="promotorId"
                  appShowErrorMessages
                  requiredMessage="Selecionar Operador é obrigatório"
                  (change)="atualizaPromotor(idPromotor)">
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let vendedor of vendedores" value="{{ vendedor.id }}">{{ vendedor.nome }}</option>
          </select>
              </div>
            </div>
          </form>
            <div class="row">
              <div class="col-xs-12" *ngIf="timeline.usuarioAcao">
                  <div class="centered">
                    <div class="operator">
                        <img class="user-photo img-margin" [src]="timeline.urlFotoUsuarioAcao" alt="Foto do usuário." appFallbackImage />
                        <span class="name">
                            <span>
                                <small>Analista</small>
                                {{ timeline.usuarioAcao }}
                            </span>
                        </span>
                    </div>
                  </div>
              </div>

              <div class="col-xs-12" *ngIf="timeline.informacaoComplementar?.descricao">
                  <div class="p descricao-complemento">
                      {{ timeline.informacaoComplementar?.descricao }}
                  </div>
              </div>
              <div padding-bottom-15 class="col-xs-12" *ngIf="timeline.informacaoComplementar?.acoes">
                <div *ngFor="let acao of timeline.informacaoComplementar.acoes; first as isFirst">
                  <button [className]="isFirst ? 'btn btn-full-orange' : 'btn btn-border-orange mt15'" [disabled]="!formValid" (click)="executarAcao(acao)">{{acoes[acao]}}</button>
                </div>
              </div>

              <div *ngIf="timeline.informacaoComplementar?.documentosPendentes" class="col-xs-12">
                <app-upload-arquivos-multiavalistas
                  [origem]="proposta.grupo2 === 'MICROCRÉDITO-RL' ? 14 : 9"
                  [isOrigemSos]="false"
                  [documentos]="timeline.informacaoComplementar?.documentosPendentes"
                  [idFicha]="proposta.id"
                  [cliente]="proposta.cliente"
                  [cpfAvalistas]="cpfAvalistas"
                  (pushDocumentacao)="pushDocumentacao()">
                </app-upload-arquivos-multiavalistas>
              </div>
            </div>


            <app-sos *ngIf="timeline.informacaoComplementar?.sos" [sos]="timeline.informacaoComplementar?.sos" [proposta]="proposta" (sosEnviado)="reload()" [local]="localSos"></app-sos>
        </div>
      </div>
  </div>
</div>
